import { CircularProgress, Tab, Tabs } from '@mui/material';
import { InboxViewModel } from '../viewModel/useInbox.viewModel';
import { InboxChat } from './InboxChat';
import { InboxBlockedUsers } from './InboxBlockedUsers';
import { UserEmailModal } from '@client/new/community/components/UserEmailModal';

export const InboxTabs = (p: InboxViewModel) => {
  if (!p.chat.chatClient) {
    return (
      <div className="w-full h-full justify-center items-center">
        <CircularProgress />
      </div>
    );
  }

  return (
    <>
      <Tabs
        value={p.activeTab}
        onChange={(ev, value) => p.setTab(value)}
        className="mb-[30px] border-b-[#ECEDF2] border-b-[3px]"
      >
        <Tab label="Messages" value="chat" className="w-min md:w-[300px]" />
        <Tab
          label="Blocked users"
          value="blockedUsers"
          className="w-min md:w-[300px]"
        />
      </Tabs>
      {p.activeTab === 'chat' && (
        <InboxChat
          {...p.chat}
          chatClient={p.chat.chatClient}
          key={p.chatRefreshKey}
        />
      )}
      {p.activeTab === 'blockedUsers' && (
        <InboxBlockedUsers {...p.blockedUsersList} />
      )}
      <UserEmailModal {...p.userInfoModal} />
    </>
  );
};
